import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveBoostInputClass;
function SaveBoostInput() {
  if (SaveBoostInputClass === VOID) {
    class $ {
      constructor(partyId) {
        this.a6r_1 = partyId;
      }
      toString() {
        return 'SaveBoostInput(partyId=' + this.a6r_1.toString() + ')';
      }
      hashCode() {
        return this.a6r_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveBoostInput()))
          return false;
        if (!this.a6r_1.equals(other.a6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveBoostInput');
    SaveBoostInputClass = $;
  }
  return SaveBoostInputClass;
}
//region block: exports
export {
  SaveBoostInput as SaveBoostInputjajsjdtwe7t7,
};
//endregion

//# sourceMappingURL=SaveBoostInput.mjs.map
